<nz-card nzTitle="Mould Card Details">
  <nz-skeleton
    [nzActive]="true"
    [nzLoading]="(loading$ | async) ?? false"
    [nzParagraph]="{ rows: 2 }"
  >
    <ng-container *ngIf="error$ | async as errorMsg; else result">
      <em-error-result [subTitle]="errorMsg"></em-error-result>
    </ng-container>
  </nz-skeleton>
</nz-card>

<ng-template #result>
  <ng-container *ngIf="pfd$ | async as performance; else noRtfData">
    <nz-row [nzGutter]="16">
      <nz-col [nzSpan]="12">
        <nz-statistic
          [nzValue]="(performance.runtimeFactor | number: '0.0-3') ?? undefined"
          nzTitle="RTF"
        ></nz-statistic>
      </nz-col>
      <nz-col [nzSpan]="12">
        <nz-statistic [nzValue]="performance.cycleTime" nzTitle="Cycle (Ct)"></nz-statistic>
      </nz-col>
    </nz-row>
  </ng-container>
</ng-template>

<ng-template #noRtfData>
  <nz-row [nzGutter]="16">
    <nz-col [nzSpan]="12">
      <nz-statistic nzValue="No Data" nzTitle="RTF"></nz-statistic>
    </nz-col>
    <nz-col [nzSpan]="12">
      <nz-statistic nzValue="No Data" nzTitle="Cycle (Ct)"></nz-statistic>
    </nz-col>
  </nz-row>
</ng-template>
